import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonDirective } from '@innersource/common-ui-components';
import { Message } from '../../chat.model';
import { ChatAttachmentTileComponent } from '../../chat-attachment-tile/chat-attachment-tile.component';
import { formatDateTime } from '../../../utils/helper';

/** Renders a user message and its copy action. */
@Component({
  selector: 'app-user-message',
  standalone: true,
  imports: [MatTooltipModule, ButtonDirective, ChatAttachmentTileComponent],
  templateUrl: './user-message.component.html',
  styleUrl: './user-message.component.scss',
})
export class UserMessageComponent {
  /** Inputs. */
  readonly message = input.required<Message>();
  readonly showTimestamp = input(true);

  /** The persisted creation time formatted for the footer. */
  readonly formattedCreatedAt = computed(() => {
    const createdAt = this.message().createdAt;
    if (!createdAt) return '';
    return formatDateTime(createdAt);
  });

  /** Copies the message text. */
  onCopy(): void {
    void navigator.clipboard.writeText(this.message().text);
  }
}
